import type { AffiliateAdminLedgerRowSchema } from '@/api/gen'

/**
 * The ledger's money contract in one place: what a money value can be, and what
 * an absent one means. Every money field on `AffiliateAdminLedgerRowSchema` is
 * REQUIRED on the BE schema (gto-wizard#2594) — the wire always carries all
 * three. An absent one is therefore a contract breach (only reachable against an
 * API older than #2594), never "this partner has $0", and must not render as a
 * confident $0.00 on the screen ops builds a payout run from.
 */

export type MoneyValue = number | string | null | undefined

export const REQUIRED_MONEY_FIELDS = [
  'balance_available_usd',
  'balance_locked_usd',
  'requested_payouts_usd',
] as const satisfies readonly (keyof AffiliateAdminLedgerRowSchema)[]

export const isAbsent = (value: MoneyValue): boolean => value == null
